import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  Link$_get_to_$ref_jq7esp1qhuglz6kwpan as Link$_get_to_$ref_jq7esp,
  Link$_set_to_$ref_i9gu5xmkiv49juwaf as Link$_set_to_$ref_i9gu5x,
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  TableSemantic_getInstance3cbunlgg7bvuu as TableSemantic_getInstance,
  TableHeaderSemantic_getInstanceqomb25yoya3n as TableHeaderSemantic_getInstance,
  TableHeaderLeftSemantic_getInstance1e4eceqp04ppd as TableHeaderLeftSemantic_getInstance,
  TableFooterLeftSemantic_getInstance1b61o9gvheh34 as TableFooterLeftSemantic_getInstance,
  TableHeaderRightSemantic_getInstance1159xojxgn34t as TableHeaderRightSemantic_getInstance,
  TableFooterRightSemantic_getInstance2ukhshj89nvz4 as TableFooterRightSemantic_getInstance,
  TableRowSemantic_getInstance396gywh21vbqh as TableRowSemantic_getInstance,
  TableCellSemantic_getInstancej0y7idum3jgg as TableCellSemantic_getInstance,
} from '../../theme/semantics.mjs';
import {
  themed2vu67ornd4jps as themed,
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance,
  None_instance1vdtnxdfytk8h as None_instance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  shownWhen3t7othivfr11 as shownWhen,
  weight31wqab1913ly4 as weight,
  align3syrmjzjb5jar as align,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { emptyRow1djlr0t4x675n as emptyRow } from './view-utilities.mjs';
import { colOfv2oygjkn5hb2 as colOf } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrollingHorizontally27coz76tiofr2 as get_scrollingHorizontally,
  get_unpadded1ygmnwh0rw79t as get_unpadded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { get_atStart2tusd7ehy6hjj as get_atStart } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Recycler21f097l2zl8cft as Recycler2 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.mjs';
import { children1vanzv8wlhhqv as children } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/db/RecyclerViewExt.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Dimension__toString_impl_o4q1ad26wkwcghhu2zh as Dimension__toString_impl_o4q1ad,
  Dimension__hashCode_impl_p583vw23xta4b9uvomj as Dimension__hashCode_impl_p583vw,
  Align_Center_getInstance366ihr7rj12mu as Align_Center_getInstance,
  Align_Start_getInstance48vaevgl3nrq as Align_Start_getInstance,
  Align_Stretch_getInstance2huaa6rbagugp as Align_Stretch_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function table(_this__u8e3s4, data, destination, columns, rowTheme) {
  var tmp;
  if (rowTheme === VOID) {
    tmp = table$lambda;
  } else {
    tmp = rowTheme;
  }
  rowTheme = tmp;
  var tmp0_columns = columns.slice();
  return table_0(_this__u8e3s4, data, ($this$table, it) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.link' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (Link())($this$table.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$table.willAddChild_hz2iwc_k$(element);
    var tmp = KMutableProperty0();
    var tmp_0 = Link$_get_to_$ref_jq7esp(element);
    var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
    element.invoke_bnq13k_k$(tmp_1, ($this$label) => {
      var v = $this$label.invoke_r7m7el_k$(it);
      return () => destination(v);
    });
    element.onStartup_vrxh3i_k$();
    $this$table.addChild_2qpft2_k$(element);
    return element;
  }, tmp0_columns, rowTheme);
}
function tableRecycler(_this__u8e3s4, data, destination, columns, rowTheme) {
  var tmp;
  if (rowTheme === VOID) {
    tmp = tableRecycler$lambda;
  } else {
    tmp = rowTheme;
  }
  rowTheme = tmp;
  var tmp0_columns = columns.slice();
  return tableRecycler_0(_this__u8e3s4, data, ($this$tableRecycler, it) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.link' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (Link())($this$tableRecycler.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$tableRecycler.willAddChild_hz2iwc_k$(element);
    var tmp = KMutableProperty0();
    var tmp_0 = Link$_get_to_$ref_jq7esp(element);
    var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
    element.invoke_bnq13k_k$(tmp_1, ($this$label) => {
      var v = $this$label.invoke_r7m7el_k$(it);
      return () => destination(v);
    });
    element.onStartup_vrxh3i_k$();
    $this$tableRecycler.addChild_2qpft2_k$(element);
    return element;
  }, tmp0_columns, rowTheme);
}
function table_0(_this__u8e3s4, data, rowContainer, columns, rowTheme) {
  var tmp;
  if (rowTheme === VOID) {
    tmp = table$lambda_0;
  } else {
    tmp = rowTheme;
  }
  rowTheme = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = themed(_this__u8e3s4, TableSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  var tmp$ret$4 = themed(element, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_1 = themed(tmp$ret$4, TableHeaderSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(false);
  var inductionVariable = 0;
  var last = columns.length;
  while (inductionVariable < last) {
    var col = columns[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    var this_2 = modifier(element_0, col);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (TextView())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    this_2.willAddChild_hz2iwc_k$(element_1);
    element_1.set_wraps_9wisy1_k$(false);
    element_1.set_ellipsis_rhzl3b_k$(true);
    var tmp_0 = KMutableProperty0();
    var tmp_1 = TextView$_get_content_$ref_4pzcwl(element_1);
    var tmp_2 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(element_1));
    element_1.invoke_bnq13k_k$(tmp_2, table$lambda_1(col));
    element_1.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_1);
  }
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  emptyRow(shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(data).isEmpty_y1axqb_k$()));
  var tmp_3 = themed(element, TableSemantic_getInstance());
  colOf(tmp_3, data, VOID, VOID, VOID, ($this$colOf, datum) => {
    itemRow($this$colOf, rowContainer, datum, columns, rowTheme);
    return Unit_instance;
  });
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return element;
}
function tableWithSticky(_this__u8e3s4, data, rowContainer, rowHeight, reactiveStickyColumns, reactiveColumns, rowTheme) {
  var tmp;
  if (rowTheme === VOID) {
    tmp = tableWithSticky$lambda;
  } else {
    tmp = rowTheme;
  }
  rowTheme = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_0 = themed(_this__u8e3s4, TableSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  element.set_gap_jwjroq_k$(get_px(0));
  var hasFooter = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var tmp0 = plus($this$remember.invoke_r7m7el_k$(reactiveStickyColumns), $this$remember.invoke_r7m7el_k$(reactiveColumns));
    var tmp$ret$4;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection())) {
        tmp = tmp0.isEmpty_y1axqb_k$();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$4 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        if (!(element.footer_1 == null)) {
          tmp$ret$4 = true;
          break $l$block_0;
        }
      }
      tmp$ret$4 = false;
    }
    return tmp$ret$4;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_1 = themed(element, TableSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  var tmp$ret$10 = themed(element_0, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_2 = themed(tmp$ret$10, TableHeaderLeftSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_2.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(false);
  var $this$row = element_1;
  reactive($this$row, VOID, ($this$reactive) => {
    $this$row.clearChildren_eufjq4_k$();
    var _iterator__ex2g4s = $this$reactive.invoke_r7m7el_k$(reactiveStickyColumns).iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var col = _iterator__ex2g4s.next_20eer_k$();
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_0 = modifier($this$row, col);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (TextView())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_0.willAddChild_hz2iwc_k$(element);
      element.set_wraps_9wisy1_k$(false);
      element.set_ellipsis_rhzl3b_k$(true);
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
      element.invoke_bnq13k_k$(tmp_1, tableWithSticky$lambda$lambda(col));
      element.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element);
    }
    return Unit_instance;
  });
  element_1.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_1);
  emptyRow(shownWhen(element_0, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(data).isEmpty_y1axqb_k$()));
  var tmp_0 = themed(element_0, TableSemantic_getInstance());
  colOf(tmp_0, data, VOID, VOID, VOID, ($this$colOf, datum) => {
    itemRow_0(sizeConstraints($this$colOf, VOID, VOID, VOID, VOID, VOID, VOID, rowHeight), rowContainer, datum, reactiveStickyColumns, rowTheme);
    return Unit_instance;
  });
  // Inline function 'com.lightningkite.kiteui.views.important' call
  var this_3 = shownWhen(element_0, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(hasFooter));
  var tmp$ret$18 = themed(this_3, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_4 = themed(tmp$ret$18, TableFooterLeftSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (RowOrCol())(this_4.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_4.willAddChild_hz2iwc_k$(element_2);
  element_2.set_vertical_nuap32_k$(false);
  var $this$row_0 = element_2;
  reactive($this$row_0, VOID, ($this$reactive) => {
    $this$row_0.clearChildren_eufjq4_k$();
    var _iterator__ex2g4s = $this$reactive.invoke_r7m7el_k$(reactiveStickyColumns).iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var col = _iterator__ex2g4s.next_20eer_k$();
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_0 = modifier($this$row_0, col);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (TextView())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_0.willAddChild_hz2iwc_k$(element);
      element.set_wraps_9wisy1_k$(false);
      element.set_ellipsis_rhzl3b_k$(true);
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
      element.invoke_bnq13k_k$(tmp_1, tableWithSticky$lambda$lambda_0(col));
      element.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element);
    }
    return Unit_instance;
  });
  element_2.onStartup_vrxh3i_k$();
  this_4.addChild_2qpft2_k$(element_2);
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp$ret$26 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  var this_5 = get_scrollingHorizontally(tmp$ret$26);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Frame())(this_5.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_5.willAddChild_hz2iwc_k$(element_3);
  element_3.onStartup_vrxh3i_k$();
  this_5.addChild_2qpft2_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_6 = themed(get_atStart(element_3), TableSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (RowOrCol())(this_6.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  this_6.willAddChild_hz2iwc_k$(element_4);
  element_4.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  var tmp$ret$34 = themed(element_4, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_7 = themed(tmp$ret$34, TableHeaderRightSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_5 = new (RowOrCol())(this_7.get_context_h02k06_k$());
  ensureOutermostElement(element_5);
  this_7.willAddChild_hz2iwc_k$(element_5);
  element_5.set_vertical_nuap32_k$(false);
  var $this$row_1 = element_5;
  reactive($this$row_1, VOID, ($this$reactive) => {
    $this$row_1.clearChildren_eufjq4_k$();
    var _iterator__ex2g4s = $this$reactive.invoke_r7m7el_k$(reactiveColumns).iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var col = _iterator__ex2g4s.next_20eer_k$();
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_0 = modifier($this$row_1, col);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (TextView())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_0.willAddChild_hz2iwc_k$(element);
      element.set_align_ypalx0_k$(col.headerAlignment_1);
      element.set_wraps_9wisy1_k$(false);
      element.set_ellipsis_rhzl3b_k$(true);
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
      element.invoke_bnq13k_k$(tmp_1, tableWithSticky$lambda$lambda_1(col));
      element.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element);
    }
    return Unit_instance;
  });
  element_5.onStartup_vrxh3i_k$();
  this_7.addChild_2qpft2_k$(element_5);
  emptyRow(shownWhen(element_4, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(data).isEmpty_y1axqb_k$()));
  var tmp_1 = themed(element_4, TableSemantic_getInstance());
  colOf(tmp_1, data, VOID, VOID, VOID, ($this$colOf, datum) => {
    itemRow_0(sizeConstraints($this$colOf, VOID, VOID, VOID, VOID, VOID, VOID, rowHeight), rowContainer, datum, reactiveColumns, rowTheme);
    return Unit_instance;
  });
  // Inline function 'com.lightningkite.kiteui.views.important' call
  var this_8 = shownWhen(element_4, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(hasFooter));
  var tmp$ret$42 = themed(this_8, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_9 = themed(tmp$ret$42, TableFooterRightSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_6 = new (RowOrCol())(this_9.get_context_h02k06_k$());
  ensureOutermostElement(element_6);
  this_9.willAddChild_hz2iwc_k$(element_6);
  element_6.set_vertical_nuap32_k$(false);
  var $this$row_2 = element_6;
  reactive($this$row_2, VOID, ($this$reactive) => {
    $this$row_2.clearChildren_eufjq4_k$();
    var _iterator__ex2g4s = $this$reactive.invoke_r7m7el_k$(reactiveColumns).iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var col = _iterator__ex2g4s.next_20eer_k$();
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_0 = modifier($this$row_2, col);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (TextView())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_0.willAddChild_hz2iwc_k$(element);
      element.set_wraps_9wisy1_k$(false);
      element.set_ellipsis_rhzl3b_k$(true);
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
      element.invoke_bnq13k_k$(tmp_1, tableWithSticky$lambda$lambda_2(col));
      element.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element);
    }
    return Unit_instance;
  });
  element_6.onStartup_vrxh3i_k$();
  this_9.addChild_2qpft2_k$(element_6);
  element_4.onStartup_vrxh3i_k$();
  this_6.addChild_2qpft2_k$(element_4);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return element;
}
function tableRecycler_0(_this__u8e3s4, data, rowContainer, columns, rowTheme) {
  var tmp;
  if (rowTheme === VOID) {
    tmp = tableRecycler$lambda_0;
  } else {
    tmp = rowTheme;
  }
  rowTheme = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  var this_0 = themed(_this__u8e3s4, TableSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  var tmp$ret$4 = themed(element, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_1 = themed(tmp$ret$4, TableHeaderSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_1.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(false);
  var inductionVariable = 0;
  var last = columns.length;
  while (inductionVariable < last) {
    var col = columns[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    var this_2 = modifier(element_0, col);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (TextView())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    this_2.willAddChild_hz2iwc_k$(element_1);
    element_1.set_wraps_9wisy1_k$(false);
    element_1.set_ellipsis_rhzl3b_k$(true);
    var tmp_0 = KMutableProperty0();
    var tmp_1 = TextView$_get_content_$ref_4pzcwl(element_1);
    var tmp_2 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(element_1));
    element_1.invoke_bnq13k_k$(tmp_2, tableRecycler$lambda_1(col));
    element_1.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_1);
  }
  element_0.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_0);
  emptyRow(shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(data)).isEmpty_y1axqb_k$()));
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp$ret$12 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.recyclerView' call
  var this_3 = themed(tmp$ret$12, TableSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = Recycler2().new_com_lightningkite_kiteui_views_l2_Recycler2_cdij9p_k$(this_3.get_context_h02k06_k$(), true, null);
  ensureOutermostElement(element_2);
  this_3.willAddChild_hz2iwc_k$(element_2);
  element_2.get_children_4cwbp4_k$();
  var tmp_3 = tableRecycler$lambda_2;
  children(element_2, data, tmp_3, ($this$children, datum) => {
    itemRow($this$children, rowContainer, datum, columns, rowTheme);
    return Unit_instance;
  });
  element_2.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_2);
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
  return element;
}
function itemRow(_this__u8e3s4, rowContainer, datum, columns, rowTheme) {
  var tmp;
  if (rowTheme === VOID) {
    tmp = itemRow$lambda;
  } else {
    tmp = rowTheme;
  }
  rowTheme = tmp;
  var tmp_0 = themed(_this__u8e3s4, TableRowSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_0 = rowContainer(dynamicThemed(tmp_0, ($this$dynamicThemed) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    return rowTheme($this$dynamicThemed, $this$dynamicThemed.invoke_r7m7el_k$(datum));
  }), datum);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  var inductionVariable = 0;
  var last = columns.length;
  while (inductionVariable < last) {
    var col = columns[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    col.render_1(modifier(element, col), datum);
  }
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
}
function itemRow_0(_this__u8e3s4, rowContainer, datum, reactiveColumns, rowTheme) {
  var tmp;
  if (rowTheme === VOID) {
    tmp = itemRow$lambda_0;
  } else {
    tmp = rowTheme;
  }
  rowTheme = tmp;
  var tmp_0 = themed(_this__u8e3s4, TableRowSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_0 = rowContainer(dynamicThemed(tmp_0, ($this$dynamicThemed) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    return rowTheme($this$dynamicThemed, $this$dynamicThemed.invoke_r7m7el_k$(datum));
  }), datum);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_0.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  var $this$row = element;
  reactive($this$row, VOID, ($this$reactive) => {
    $this$row.clearChildren_eufjq4_k$();
    var _iterator__ex2g4s = $this$reactive.invoke_r7m7el_k$(reactiveColumns).iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var col = _iterator__ex2g4s.next_20eer_k$();
      col.render_1(modifier($this$row, col), datum);
    }
    return Unit_instance;
  });
  element.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element);
}
var WeightClass;
function Weight() {
  if (WeightClass === VOID) {
    class $ {
      constructor(weight) {
        this.weight_1 = weight;
      }
      toString() {
        return 'Weight(weight=' + this.weight_1 + ')';
      }
      hashCode() {
        return getNumberHashCode(this.weight_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Weight()))
          return false;
        if (!equals(this.weight_1, other.weight_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Weight');
    WeightClass = $;
  }
  return WeightClass;
}
var FixedClass;
function Fixed() {
  if (FixedClass === VOID) {
    class $ {
      constructor(width) {
        this.width_1 = width;
      }
      toString() {
        return 'Fixed(width=' + Dimension__toString_impl_o4q1ad(this.width_1) + ')';
      }
      hashCode() {
        return Dimension__hashCode_impl_p583vw(this.width_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Fixed()))
          return false;
        if (!equals(this.width_1, other.width_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Fixed');
    FixedClass = $;
  }
  return FixedClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      text_y5ktm4_k$(name, weight, path) {
        var tmp = new (Weight())(weight);
        return new (TableColumn())(name, tmp, VOID, VOID, VOID, ($this$TableColumn, it) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())($this$TableColumn.get_context_h02k06_k$());
          ensureOutermostElement(element);
          $this$TableColumn.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
            return path($this$invoke, $this$invoke.invoke_r7m7el_k$(it));
          });
          element.onStartup_vrxh3i_k$();
          $this$TableColumn.addChild_2qpft2_k$(element);
          return Unit_instance;
        });
      }
      text$default_gwb2zv_k$(name, weight, path, $super) {
        weight = weight === VOID ? 1.0 : weight;
        return $super === VOID ? this.text_y5ktm4_k$(name, weight, path) : $super.text_y5ktm4_k$.call(this, name, weight, path);
      }
      custom_k0krgj_k$(name, weight, render) {
        return new (TableColumn())(name, new (Weight())(weight), VOID, VOID, VOID, render);
      }
      custom$default_tn6l2s_k$(name, weight, render, $super) {
        weight = weight === VOID ? 1.0 : weight;
        return $super === VOID ? this.custom_k0krgj_k$(name, weight, render) : $super.custom_k0krgj_k$.call(this, name, weight, render);
      }
      text_otwg0k_k$(name, dimension, path) {
        var tmp = new (Fixed())(dimension);
        return new (TableColumn())(name, tmp, VOID, VOID, VOID, ($this$TableColumn, it) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())($this$TableColumn.get_context_h02k06_k$());
          ensureOutermostElement(element);
          $this$TableColumn.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
            return path($this$invoke, $this$invoke.invoke_r7m7el_k$(it));
          });
          element.onStartup_vrxh3i_k$();
          $this$TableColumn.addChild_2qpft2_k$(element);
          return Unit_instance;
        });
      }
      custom_dlzbwd_k$(name, dimension, render) {
        return new (TableColumn())(name, new (Fixed())(dimension), VOID, VOID, VOID, render);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var TableColumnClass;
function TableColumn() {
  if (TableColumnClass === VOID) {
    class $ {
      constructor(name, sizing, verticalAlign, footer, headerAlignment, render) {
        verticalAlign = verticalAlign === VOID ? Align_Center_getInstance() : verticalAlign;
        footer = footer === VOID ? null : footer;
        headerAlignment = headerAlignment === VOID ? Align_Start_getInstance() : headerAlignment;
        this.name_1 = name;
        this.sizing_1 = sizing;
        this.verticalAlign_1 = verticalAlign;
        this.footer_1 = footer;
        this.headerAlignment_1 = headerAlignment;
        this.render_1 = render;
      }
    }
    initMetadataForClass($, 'TableColumn');
    TableColumnClass = $;
  }
  return TableColumnClass;
}
function modifier(_this__u8e3s4, column) {
  var sizing = column.sizing_1;
  var tmp;
  if (sizing instanceof Weight()) {
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    var this_0 = get_unpadded(themed(weight(_this__u8e3s4, sizing.weight_1), TableCellSemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (Frame())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
    var this_1 = align(element, Align_Stretch_getInstance(), column.verticalAlign_1);
    tmp = themed(this_1, ForcePaddingSemantic_getInstance());
  } else {
    if (sizing instanceof Fixed()) {
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      var this_2 = get_unpadded(themed(sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, sizing.width_1), TableCellSemantic_getInstance()));
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (Frame())(this_2.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      this_2.willAddChild_hz2iwc_k$(element_0);
      element_0.onStartup_vrxh3i_k$();
      this_2.addChild_2qpft2_k$(element_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
      var this_3 = align(element_0, Align_Stretch_getInstance(), column.verticalAlign_1);
      tmp = themed(this_3, ForcePaddingSemantic_getInstance());
    } else {
      noWhenBranchMatchedException();
    }
  }
  return tmp;
}
function table$lambda(_this__u8e3s4, it) {
  return None_instance;
}
function tableRecycler$lambda(_this__u8e3s4, it) {
  return None_instance;
}
function table$lambda_0(_this__u8e3s4, it) {
  return None_instance;
}
function table$lambda_1($col) {
  return ($this$invoke) => $col.name_1($this$invoke);
}
function tableWithSticky$lambda(_this__u8e3s4, it) {
  return None_instance;
}
function tableWithSticky$lambda$lambda($col) {
  return ($this$invoke) => $col.name_1($this$invoke);
}
function tableWithSticky$lambda$lambda_0($col) {
  return ($this$invoke) => {
    var tmp0_safe_receiver = $col.footer_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver($this$invoke);
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  };
}
function tableWithSticky$lambda$lambda_1($col) {
  return ($this$invoke) => $col.name_1($this$invoke);
}
function tableWithSticky$lambda$lambda_2($col) {
  return ($this$invoke) => {
    var tmp0_safe_receiver = $col.footer_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver($this$invoke);
    return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
  };
}
function tableRecycler$lambda_0(_this__u8e3s4, it) {
  return None_instance;
}
function tableRecycler$lambda_1($col) {
  return ($this$invoke) => $col.name_1($this$invoke);
}
function tableRecycler$lambda_2(it) {
  return it.get__id_18jb1r_k$();
}
function itemRow$lambda(_this__u8e3s4, it) {
  return None_instance;
}
function itemRow$lambda_0(_this__u8e3s4, it) {
  return None_instance;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance35wmauq2koet0,
  Fixed as Fixedsogarmaf088q,
  TableColumn as TableColumn199vk8dy8jaqx,
  tableRecycler_0 as tableRecycler3rsrjjwywx3ie,
  tableRecycler as tableRecycler8sos3tuo7qum,
  tableWithSticky as tableWithSticky1958em9ua7p76,
  table_0 as tablezpetcq9vbay1,
  table as table1wgqnzrzsmc0y,
};
//endregion

//# sourceMappingURL=table.mjs.map
